import * as React from 'react';

import * as mui from '@material-ui/core';
import {CSSProperties} from '@material-ui/core/styles/withStyles';
import {Theme, withStyles} from '@material-ui/core/styles';


export const APP_TITLE=`Clouds's Spice v3`;

export const APP_NAME='SPICE';
export const APP_NAME_JSX=<span>SPICE</span>;


export const APP_EP_NAME=`${APP_NAME}端末`;


///// 固有名詞はここに定義する /////

interface PNDATA {
    label: string;
    annotation: string;
}

const PNTBL: { [k:string]: PNDATA } = {
    SUICA:  {
        label: `Suica`,
        annotation: `Suica（スイカ）は、東日本旅客鉄道（JR東日本）・東京モノレール・東京臨海高速鉄道等で導入されている共通乗車カード・電子マネーで、JR東日本の登録商標です`,
    },

    REGISTRATION_INFORMATION: {label: '登録情報', annotation: '本サービスを利用開始するために必要な情報'},

    CUSTOMER_ID: {label: 'カスターマーID', annotation: '本サービスを利用する利用者のID。新規登録時のみ利用する。'},
    CUSTOMER_REGISTRATION_CODE: {label: 'カスタマー登録コード', annotation: '新規登録時に必要なコード。弊社より別途発行いたします。'},
    CUSTOMER_ACCOUNT_DISPLAY_NAME: {label: 'アカウント表示名', annotation: '本サービス内でこのアカウントを識別するために表示する名称'},
    CUSTOMER_ACCOUNT_UID: {label: 'ユーザーID（管理者用）', annotation: '御社管理者が管理サイトへのログイン時に入力するID'},
    CUSTOMER_ACCOUNT_PWD: {label: 'パスワード（管理者用）', annotation: '御社管理者が管理サイトへのログイン時に入力するパスワード'},
    CUSTOMER_ACCOUNT_PWD_CONFIRM: {label: 'パスワード再入力（管理者用）', annotation: ''},
    CUSTOMER_ACCOUNT_EMAIL: {label: 'メールアドレス（管理者用）', annotation: '本サービスで発生するイベント等の自動送信メールを受け取るためのメールアドレス'},
    CUSTOMER_ACCOUNT_INFORMATION: {label: '管理者アカウント情報', annotation: '御社管理者が本サービスの管理サイトを利用するための情報'},

    USER_ACCOUNT: {label: 'ユーザーアカウント', annotation: '御社管理者が管理サイトへのログイン時に入力するID'},
    SPICE_USER_ACCOUNT: {label: 'Spice利用者アカウント', annotation: 'Spice利用者アカウント'},

    TRANSITMANAGER: { label: 'transit manager', annotation: '本サービスへ交通費情報を入力可能な外部サービス' },
    TRANSITMANAGER_PRIVKEY: { label: '秘密鍵（transit manager）', annotation: '外部サービス「transit manager」のお客様管理者向け画面「自社設定情報」で確認可能です' },
    TRANSITMANAGER_SALESID: { label: 'お客様番号1', annotation: '外部サービス「transit manager」の「お客様番号1」' },
    TRANSITMANAGER_CUSTOMERID: { label: 'お客様番号2', annotation: '外部サービス「transit manager」の「お客様番号2」' },
    TRANSITMANAGER_FQDN: { label: 'FQDN', annotation: '外部サービス「transit manager」の「FQDN」' },
    TRANSITMANAGER_USERNO: { label: '社員番号(tm)', annotation: '外部サービス「transit manager」の「社員番号」' },
    
    TEAMSPIRIT_EMPCODE: { label: 'Teamspirit社員コード', annotation: 'Teamspirit社員コード' },

    SALESFORCE:{ label: 'Salesforce', annotation: '' },

    EXPENSE_EXT_SOURCE_TIP__tm: { label: 'transit manager 上の情報を表示しています', annotation: ''  }
};

export class PNCtx {

    used: { [k:string]: PNDATA } = {};
    

    get(key: string) {

        key = key.toUpperCase();

        const r = PNTBL[key];

        if(r) {
            this.used[key] = r;
            return r.label;
        }

        this.used[key] ={
            label: `?${key}?`,
            annotation: `固有名詞定義エラー`
        };

        return `?${key}?`;
    }


}



const pnStyles = (theme: Theme)  => ({
    pnDefined: {
    } as CSSProperties,
    pnUndefined: {
    } as CSSProperties,
  });
type PNClassNames = 'pnDefined'|'pnUndefined';
  

  
interface PNProps {
    ctx: PNCtx;
    quote?: boolean;
}

class PNImpl extends React.Component<PNProps  &  mui.WithStyles<PNClassNames> > {


    getElement(key: string) {
        const classes = this.props.classes;

        const r = PNTBL[key];

        if(r) {
            this.props.ctx.used[key] = r;
            return <span className={classes.pnDefined} >{this.props.quote?'`':''}{r.label}{this.props.quote?'`':''}</span>;
        }

        this.props.ctx.used[key] ={
            label: `?${key}?`,
            annotation: `固有名詞定義エラー`
        };
        return <span className={classes.pnUndefined}>{this.props.quote?'`':''}?{key}?{this.props.quote?'`':''}</span>;

    }


    render() {
        return this.getElement(this.props.children as string);
    }
}
export const PN = withStyles(pnStyles)(PNImpl);

export class PNAnnotation  extends React.Component<PNProps> {


    render() {
        const r:JSX.Element[] = [];

        Object.keys(this.props.ctx.used).forEach(k=>{
            const pn = this.props.ctx.used[k];
            r.push(<React.Fragment key={k}><dt>{pn.label}</dt><dd>{pn.annotation}</dd></React.Fragment>);
            
            if(pn.annotation === '固有名詞定義エラー') {
                console.log(`${k}: {label: '${pn.label}', annotation: ''}`);
            }
        });


        return (

            <dl style={{fontSize: 'xx-small'}}>
            {r}
            </dl>

        );
    }

}